/**
 * Rótulos de resolução de solicitação de alerta (padronizado na UI).
 */
export function getAlertRequestResolutionLabel(resolution) {
  if (resolution === "created") return "Alerta Criado";
  if (resolution === "rejected") return "Rejeitado";
  if (!resolution) return "Pendente";
  return String(resolution);
}

export function isAlertRequestCreated(resolution) {
  return resolution === "created";
}
